<template>
  <div>
    <div class="top-padding">
      <div class="schedule-top-wrap" id="g-contents">
        <!-- 현재 날짜 -->
        <div class="schedule-top">
          <p class="sch-top-text">오늘은 <strong>{{ getDate('date') }}</strong>입니다.</p>
          <p class="sch-now-time">현재 {{ getDate('time') }}</p>
          <button @click="now()" class="sch-now-btn">NOW</button>
        </div>
        <!-- 날짜 리스트 -->
        <ul class="schedule-day">
          <li v-for="(date, index) in dateList" :key="index" :class="dateIndex === index ? 'sch-today' : ''" @click.prevent="dateTab(index)">
            <button><span>{{ date.week }}</span>{{ date.day }}</button>
          </li>
        </ul>
      </div>

      <!-- 시간 리스트 -->
      <div class="sch-t-time-wrap">
        <div class="sch-t-time">
          <button v-for="(data, index) in 24" :key="index" @click="timeClick(index)" :class="selectedClass(index)">
            {{ index }}
          </button>
          <div class="sch-scroll" :style="'left:' + timeWidth + 'px;'"></div>
          <!--시간 한칸 : 51px -->
        </div>
      </div>

      <div class="sch-body-wrap">
        <!-- 시간 네비게이터 -->
        <div class="tt-top">
          <div class="swiper-container sche-time-slider">
            <div class="swiper-wrapper">
              <div v-for="(data, index) in 24" :key="index" class="swiper-slide">
                <p :class="'tt-time ' + timeActive(index)">{{ pad(index, 2) }}:00</p>
              </div>
            </div>

            <div class="swiper-button-prev" @click="timeMove('prev')">
              <button class="titmetable-btn-left"><img src="../../assets/images/schedule/btn-titmetable-arrow-left.png" alt="이전 시간 보기"/></button>
            </div>
            <div class="swiper-button-next" @click="timeMove('next')">
              <button class="titmetable-btn-right"><img src="../../assets/images/schedule/btn-titmetable-arrow-right.png" alt="다음 시간 보기"/></button>
            </div>
          </div>
        </div>

        <!-- 채널 -->
        <div v-if="dataList && dataList.length" class="sch-border">
          <div class="sch-body">
            <schedule-channel v-for="(data, index) in dataList"
                              :data="data"
                              :selectYear="selectYear"
                              :selectDate="selectDate"
                              :activeTime="activeTime"
                              :endTime="endTime"
                              :chIndex="index"
                              :key="index"/>
          </div>
        </div>
        <div v-if="!dataList" class="loading-progress">
          <div class="loading loading-schedule"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from '@/mixins/swiper'
import ScheduleChannel from '@/components/schedule/ScheduleChannel'
import { getLiveEpgs } from '@/common/utils/request'
import _ from 'lodash'
import { scrollTop, setDisableScrolling } from '@/common/utils/common'
import { SET_CURRENT_MENU } from '@/common/resources/const'
import { mapMutations } from 'vuex'
import cookie from '@/common/utils/cookie'

export default {
  mixins: [
    Swiper
  ],
  components: {
    ScheduleChannel
  },
  data () {
    return {
      dataList: [], // 데이터 리스트
      dateList: [], // 일주일 날짜 리스트
      selectYear: '', // 선택한 년
      selectDate: '', // 선택한 날짜
      selectTime: '', // 선택한 시간
      startTime: '', // 조회 시작시간
      endTime: '', // 조회 종료시간
      dateIndex: 0, // 날짜 index
      timeWidth: 0, // 시간 활성화 수치
      activeTime: 0,
      swiperOptions: {
        slidesPerView: 3,
        initialSlide: 0,
        simulateTouch: false,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      },
      selectedHoursList: [],
      isPooqzone: cookie.isWavveOn()
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    // NOW 클릭
    now () {
      let today = new Date()

      this.selectYear = today.getFullYear()
      this.selectDate = this.pad(today.getMonth() + 1, 2) + '-' + this.pad(today.getDate(), 2)
      this.selectTime = this.changeSelectedTime(today.getHours())

      this.startTime =
        this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime - 1, 2))
      this.endTime =
        this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime + 2, 2))

      // 시간 영역, 슬라이드 이동, 날짜 이동
      this.timeWidth = (this.selectTime - 1) * 53
      this.swiper.slideTo(this.selectTime - 1)
      this.dateIndex = 0
      this.selectedHoursList = [this.selectTime - 1, this.selectTime, this.selectTime + 1]
      // 데이터 조회
      this.getDataList('', this.startTime, this.endTime)
    },
    // 날짜 클릭
    dateTab (index) {
      this.dateIndex = index

      let today = new Date()
      today.setDate(today.getDate() + index)

      this.selectYear = today.getFullYear()
      this.selectDate = this.pad(today.getMonth() + 1, 2) + '-' + this.pad(today.getDate(), 2)
      this.selectTime = this.changeSelectedTime(this.selectTime)

      this.startTime =
        this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime - 1, 2))
      this.endTime =
        this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime + 2, 2))

      // 데이터 조회
      this.getDataList('', this.startTime, this.endTime)
    },
    // 시간 리스트 에서 시간클릭
    timeClick (time) {
      this.selectTime = this.changeSelectedTime(time)

      // 시간 영역, 슬라이드 이동
      this.timeWidth = (this.selectTime - 1) * 53
      this.swiper.slideTo(this.selectTime - 1)

      this.startTime =
        this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime - 1, 2))
      this.endTime =
        this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime + 2, 2))

      this.selectedHoursList = [this.selectTime - 1, this.selectTime, this.selectTime + 1]
      // 데이터 조회
      this.getDataList('', this.startTime, this.endTime)
    },
    // 시간 네이게이터 좌우 버튼
    timeMove (kind) {
      if (kind === 'next') {
        if (this.selectTime === 22) {
          return
        }
        this.selectTime = Math.min(this.changeSelectedTime(this.selectTime) + 1, 22)
        this.timeWidth = (this.selectTime - 1) * 53

        this.startTime =
          this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime - 1, 2))
        this.endTime =
          this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime + 2, 2))
      } else {
        if (this.selectTime === 1) {
          return
        }
        this.selectTime = Math.max(this.changeSelectedTime(this.selectTime) - 1, 1)
        this.timeWidth = (this.selectTime - 1) * 53

        this.startTime =
          this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime - 1, 2))
        this.endTime =
          this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime + 2, 2))
      }
      this.selectedHoursList = [this.selectTime - 1, this.selectTime, this.selectTime + 1]
      // 데이터 조회
      this.getDataList('', this.startTime, this.endTime)
    },
    // 현재 날짜 시간
    getDate (type) {
      let d = new Date()
      let text = ''

      if (type === 'date') {
        let week = ['일', '월', '화', '수', '목', '금', '토']
        text = Number(d.getMonth() + 1) + '월 ' + d.getDate() + '일 ' + week[d.getDay()] + '요일'
      } else {
        let hh = this.pad(d.getHours(), 2)
        let mm = this.pad(d.getMinutes(), 2)
        text = hh + ':' + mm
      }
      return text
    },
    // 현재시간에 활성화
    timeActive (time) {
      let today = new Date()
      // getDateFromTimeString(this.data.list[i].starttime)
      let d = new Date(this.selectYear + '-' + this.selectDate)
      this.swiperOptions.initialSlide = today.getHours() - 1

      if (time === today.getHours() && today.getDay() === d.getDay()) {
        return 'tt-time-on'
      }
      return ''
    },
    // 데이터 조회
    getDataList (genre, startdatetime, enddatetime) {
      this.dataList = undefined
      this.$nextTick(() => {
        getLiveEpgs({ genre: 'all', startdatetime, enddatetime, offset: 0, limit: 100 }).then(({ data }) => {
          if (this.startTime !== _.get(data, 'startdatetime', '')) {
            return
          }
          if (this.swiper === undefined) {
            this.activeTime = this.selectTime + 1
          } else {
            this.activeTime = this.swiper.activeIndex + 1
          }
          this.dataList = _.get(data, 'list', [])
        })
      })
    },
    changeSelectedTime (t) {
      let time = t
      time = Math.max(time, 1)
      time = Math.min(time, 22)
      return time
    },
    dateFormat (year, date, time) {
      return year + '-' + date + ' ' + time + ':00'
    },
    // 지정된 자리수만큼 0을 채워주는 함수
    pad (num, width) {
      let numStr = num + ''
      return numStr.length >= width ? numStr
        : new Array((width - numStr.length) + 1).join('0') + numStr
    },
    selectedClass (index) {
      return _.includes(this.selectedHoursList, index) ? 'on' : ''
    }
  },
  created () {
    scrollTop()
    let date = new Date()
    this.selectYear = date.getFullYear()
    this.selectDate = this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate(), 2)
    this.selectTime = this.changeSelectedTime(date.getHours())
    this.selectedHoursList = [this.selectTime - 1, this.selectTime, this.selectTime + 1]

    this.startTime =
      this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime - 1, 2))
    this.endTime =
      this.dateFormat(this.selectYear, this.selectDate, this.pad(this.selectTime + 2, 2))

    // 데이터 조회
    this.getDataList('', this.startTime, this.endTime)
    // 시간 영역
    this.timeWidth = (this.selectTime - 1) * 53

    // 일주일 날짜 리스트
    let week = ['일', '월', '화', '수', '목', '금', '토']
    for (let i = 0; i < 7; i++) {
      let d = new Date()
      let weekList = { day: '', week: '' }

      d.setDate(d.getDate() + i)
      let month = d.getMonth() + 1
      let day = d.getDate()

      weekList.day = String(month) + '/' + String(day)
      weekList.week = week[d.getDay()]

      this.dateList.push(weekList)
    }
    this.$nextTick(() => {
      this.swiperElement = '.sche-time-slider'
      this.isReady = true
    })
  },
  mounted () {
    this[SET_CURRENT_MENU]('live')
    this.$nextTick(() => {
      setDisableScrolling(false)
    })
  }
}
</script>
<style lang="css" src="@/assets/css/main.css"></style>
<style lang="css" src="@/assets/css/schedule.css"></style>
